import styled from "styled-components"

export const AppBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-height: 100vh;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
`;

/** Route pages stretch to full viewport width (flex cross-axis + block sizing). */
export const AppMain = styled.main`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-self: stretch;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  flex: 1 1 0;
  box-sizing: border-box;
`;

/**
 * React Router's matched page must sit in a block that always spans AppMain's width.
 * Without this, cold refresh can leave the route subtree content-sized (~half width).
 */
export const AppRoutesShell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-self: stretch;
  width: 100%;
  min-width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  box-sizing: border-box;
`;
